export const LIST_EVAL_FAIL = "LIST_EVAL_FAIL";
export const LIST_EVAL_SUCCESS = "LIST_EVAL_SUCCESS";
export const ONE_EVAL_SUCCESS = "ONE_EVAL_SUCCESS";
export const ONE_EVAL_FAIL = "ONE_EVAL_FAIL";
export const CREATE_EVAL_SUCCESS = "CREATE_EVAL_SUCCESS";
export const CREATE_EVAL_FAIL = "CREATE_EVAL_FAIL";
export const ME_EVAL_FAIL = "ME_EVAL_FAIL";
export const ME_EVAL_SUCCESS = "ME_EVAL_SUCCESS";
export const DEACTIVATE_EVAL_SUCCESS = "DEACTIVATE_EVAL_SUCCESS";
export const DEACTIVATE_EVAL_FAIL = "DEACTIVATE_EVAL_FAIL";
export const SEARCH_EVAL_SUCCESS = "SEARCH_EVAL_SUCCESS";
export const SEARCH_EVAL_FAIL = "SEARCH_EVAL_FAIL";
export const LIST_EVAL_DESACTIVER_SUCCESS = "LIST_EVAL_DESACTIVER_SUCCESS";
export const LIST_EVAL_DESACTIVER_FAIL = "LIST_EVAL_DESACTIVER_FAIL";
export const EVALS_TO_COMPARE_SUCCESS = "EVALS_TO_COMPARE_SUCCESS";
export const EVALS_TO_COMPARE_FAIL  = "EVALS_TO_COMPARE_FAIL";
